<template>
  <div class="hc-compact-page hc-distribution-page">
    <!-- Header Card -->
        <PageHeader icon="fas fa-map-marked-alt">
      <template #title>
        Peta Sebaran Pasien {{ clinic_name }}
      </template>
      <template #subtitle>
        Visualisasi dan rincian statistik sebaran pasien berdasarkan wilayah
      </template>
    </PageHeader>

    <!-- Component List -->
    <div class="row">
      <div class="col-md-12">
        <Card card-class="distribution-chart-shell">
          <template v-slot:body>
            <DistributionMapGraphic />
          </template>
        </Card>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <Card card-class="distribution-table-shell">
          <template v-slot:body>
            <div class="distribution-table-heading">
              <div>
                <span class="distribution-eyebrow">Rincian wilayah</span>
                <h3>Data sebaran pasien</h3>
                <p>Filter dan bandingkan jumlah pasien berdasarkan wilayah.</p>
              </div>
              <div class="distribution-export-actions">
                <vue-excel-xlsx
                  :data="items"
                  :columns="columns"
                  :file-name="'peta-sebaran-pasien'"
                  :file-type="'xlsx'"
                  :sheet-name="'sheet 1'"
                >
                  <b-button class="distribution-icon-button distribution-icon-button--excel" title="Unduh Excel" aria-label="Unduh Excel">
                    <i class="fas fa-file-excel"></i>
                  </b-button>
                </vue-excel-xlsx>
                <b-button
                  class="distribution-icon-button distribution-icon-button--print"
                  title="Cetak data"
                  aria-label="Cetak data"
                  @click="btnPrintOnClick"
                >
                  <i class="fas fa-print"></i>
                </b-button>
              </div>
            </div>

            <div class="distribution-filter-bar">
              <label class="distribution-filter-field">
                <span><i class="fas fa-map-marked-alt"></i> Provinsi</span>
                <b-input-group>
                      <treeselect
                        v-model="filter.province_id"
                        :options="region"
                        placeholder="Semua provinsi"
                        @input="regionSet"
                        required
                      />
                </b-input-group>
              </label>
              <label v-if="isRegion" class="distribution-filter-field">
                <span><i class="fas fa-city"></i> Kota/Kabupaten</span>
                <b-input-group>
                      <treeselect
                        v-model="filter.capital_id"
                        :options="regionChild"
                        placeholder="Semua kota/kabupaten"
                        required
                        @input="filterByCapital"
                      />
                </b-input-group>
              </label>
            </div>

            <b-table
              striped
              hover
              class="distribution-table"
              :items="items"
              :fields="fields"
              :style="'white-space: nowrap'"
              responsive
            >
              <template #table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.key === 'actions' ? '15%' : '' }"
                />
              </template>
              <template #cell(actions)="data">
                <b-button
                  size="sm"
                  class="mr-1 btn-info"
                  v-b-tooltip.hover
                  title="Detail"
                  @click="
                    $router.push({ path: '/coas/detail/' + data.item.id })
                  "
                  ><i class="fas fa-eye px-0"></i
                ></b-button>
                <b-button
                  size="sm"
                  class="mr-1 btn-success"
                  v-b-tooltip.hover
                  title="Edit"
                  @click="$router.push({ path: '/coas/edit/' + data.item.id })"
                  v-if="btn"
                  ><i class="fas fa-edit px-0"></i
                ></b-button>
                <b-button
                  size="sm"
                  class="btn-danger"
                  v-b-tooltip.hover
                  title="Hapus"
                  @click="deleteData(data.item.id)"
                  v-if="btn"
                  ><i class="fas fa-trash px-0"></i
                ></b-button>
              </template>
            </b-table>
            <b-pagination
              v-if="items.length != 0"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              @page-click="pageOnClick"
              class="mt-4"
            ></b-pagination>
          </template>
        </Card>
      </div>
    </div>

    <DistributionMapPrint :items="items" id="printMe" class="d-none"/>
  </div>
</template>

<script>
import Card from "@/view/content/Card.vue";
import module from "@/core/modules/CrudModule.js";
import saasModule from "@/core/modules/CrudSaasModule.js";
import DistributionMapGraphic from "@/component/patients/DistributionMapGraphic.vue";
import DistributionMapPrint from "@/component/patients/DistributionMapPrint.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "List",

  components: {
    Card,
    DistributionMapGraphic,
    DistributionMapPrint,
  },

  data() {
    return {
      clinic_name : window.configuration == null ? "Medhop" : window.configuration.clinic_name,
      // Filter
      filter: {
        province_id: null,
        capital_id: null,
      },
      coa_categories: [],
      sub_ledgers: [],
      cash_flows: [],
      // Pagination
      perPage: 35,
      currentPage: 1,
      totalRows: 0,
      // Table Head
      fields: [
        {
          key: "list_number",
          label: "#",
          sortable: true,
        },
        {
          key: "name",
          label: "Wilayah",
          sortable: true,
        },
        {
          key: "total_patient",
          label: "Jumlah Pasien",
          sortable: true,
        },
        {
          key: "total_male",
          label: "Laki-laki",
          sortable: true,
        },
        {
          key: "total_female",
          label: "Perempuan",
          sortable: true,
        },
      ],
      columns: [
        {
          field: "name",
          label: "Wilayah",
        },
        {
          field: "total_patient",
          label: "Jumlah Pasien",
        },
        {
          field: "total_male",
          label: "Laki-laki",
        },
        {
          field: "total_female",
          label: "Perempuan",
        },
      ],
      // Table Items
      items: [],
      region: [],
      regionChild: [],
      isRegion: false,
      // User Access
      btn: false,
    };
  },

  methods: {
    pageOnClick(evt, page) {
      evt.preventDefault();
      this.currentPage = page;
      this.pagination();
    },

    async pagination() {
      let filterParams = `&province_id=${this.filter.province_id}&capital_id=${this.filter.capital_id}`;
      let response = await module.paginateCoa(
        `patients/distribution-map/table`,
        `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`
      );
      let pagination = response.meta.pagination;
      this.totalRows = pagination.total;

      let a, b;
      b = this.perPage * (this.currentPage - 1) + 1;
      for (a = 0; a < response.data.length; a++) {
        response.data[a].list_number = b + a;
      }
      this.items = response.data;
    },

    regionSet(evt) {
      if (typeof evt == "undefined") {
        this.filter.province_id = null;
      }
      let status = this.getRegionChildOptions(evt);
      this.pagination();

      if (status) {
        this.isRegion = true;
      }
    },

    filterByCapital(evt) {
      if (typeof evt == "undefined") {
        this.filter.capital_id = null;
      }
      this.pagination();
    },

    async getRegionOptions() {
      let response = await module.saasModule("regions");
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.region = response.data;
      }

      if (this.filter.province_id != null) {
        this.isRegion = true;
        this.getRegionChildOptions(this.filter.province_id);
      }
    },

    async getRegionChildOptions(id) {
      let response = await module.saasModule("region/" + id);
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.regionChild = response.data;
      }

      return true;
    },

    async btnPrintOnClick(){
      await this.$htmlToPaper('printMe');
    },

    setActiveButton() {
      let access_right_user = window.localStorage.getItem(
        "access_right_display"
      );
      let access_right = JSON.parse(access_right_user);

      let a;
      for (a = 0; a < access_right.length; a++) {
        if (access_right[a] == "6010") {
          this.btn = true;
        }
      }
    },
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Pasien" },
      { title: "Peta Sebaran" },
    ]);
    // Get Data
    this.pagination();
    this.setActiveButton();
    this.getRegionOptions();
  },
};
</script>

<style lang="scss">
.hc-distribution-page > .alert {
  margin-bottom: 16px !important;
}

.hc-distribution-page .distribution-chart-shell.card,
.hc-distribution-page .distribution-table-shell.card {
  border: 1px solid #e3eaf2 !important;
  border-radius: 18px !important;
  background: #fff !important;
  box-shadow: 0 10px 28px rgba(var(--skin-deep-rgb), 0.06) !important;
  transform: none !important;
}

.hc-distribution-page .distribution-chart-shell > .card-body,
.hc-distribution-page .distribution-table-shell > .card-body {
  padding: 18px !important;
}

.hc-distribution-page .distribution-table-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 16px;
}

.hc-distribution-page .distribution-eyebrow {
  display: block;
  margin-bottom: 4px;
  color: var(--skin-secondary);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.11em;
  text-transform: uppercase;
}

.hc-distribution-page .distribution-table-heading h3 {
  margin: 0 0 4px;
  color: #1a2433 !important;
  font-size: 17px !important;
  font-weight: 700;
}

.hc-distribution-page .distribution-table-heading p {
  margin: 0;
  color: #6b7280;
  font-size: 12px;
}

.hc-distribution-page .distribution-export-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.hc-distribution-page .distribution-icon-button.btn {
  display: inline-grid !important;
  width: 36px !important;
  min-width: 36px !important;
  height: 36px !important;
  min-height: 36px !important;
  padding: 0 !important;
  place-items: center;
  border-radius: 10px !important;
}

.hc-distribution-page .distribution-icon-button i {
  margin: 0 !important;
  padding: 0 !important;
  color: inherit !important;
}

.hc-distribution-page .distribution-icon-button--excel {
  color: #168078 !important;
  border: 1px solid rgba(var(--skin-secondary-rgb), 0.24) !important;
  background: rgba(var(--skin-secondary-rgb), 0.08) !important;
}

.hc-distribution-page .distribution-icon-button--print {
  color: #fff !important;
  border: 0 !important;
  background: linear-gradient(135deg, var(--skin-deep), var(--skin-primary), var(--skin-secondary)) !important;
  box-shadow: 0 6px 14px rgba(var(--skin-primary-rgb), 0.18) !important;
}

.hc-distribution-page .distribution-filter-bar {
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 300px));
  gap: 12px;
  margin-bottom: 16px;
  padding: 12px;
  border: 1px solid #e7edf4;
  border-radius: 14px;
  background: #f8fafc;
}

.hc-distribution-page .distribution-filter-field {
  display: block;
  margin: 0;
}

.hc-distribution-page .distribution-filter-field > span {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 6px;
  color: #40536b;
  font-size: 11px;
  font-weight: 700;
}

.hc-distribution-page .distribution-filter-field > span i {
  width: 14px;
  color: var(--skin-secondary);
  text-align: center;
}

.hc-distribution-page .distribution-filter-field .input-group,
.hc-distribution-page .distribution-filter-field .vue-treeselect {
  width: 100%;
}

.hc-distribution-page .distribution-table {
  margin-top: 0 !important;
}

@media (max-width: 767.98px) {
  .hc-distribution-page .distribution-chart-shell > .card-body,
  .hc-distribution-page .distribution-table-shell > .card-body {
    padding: 14px !important;
  }

  .hc-distribution-page .distribution-filter-bar {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 575.98px) {
  .hc-distribution-page .distribution-table-heading {
    flex-direction: column;
  }
}
</style>
